import * as fromCareers from '../reducers/careersReducers'

export const getCareer = (state) => fromCareers.getCareer(state.careers)
export const getCareersList = (state) => fromCareers.getCareersList(state.careers)
export const getCareersData = (state) => fromCareers.getCareersData(state.careers)
